import React from 'react';
import './App.scss';

// Note: This component is kept for SSR compatibility with @moda/portal-platform
// Client-side routing is now handled by createBrowserRouter in client.tsx
export const App: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return <div className="App">{children}</div>;
};
